import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { withChildren } from "@builder.io/react";
import { addIdAttribute } from "@glowforge/builder-components/lib/util/shared-configs";

import useUser from '../../context/UserContext/useUser';

function AuthWrapper({ children, dataTestId }) {
  const { user, userFetchState } = useUser();
  const [viewKey, setViewKey] = useState('logged-out');

  useEffect(() => {
    if (userFetchState === 'complete' && Object.entries(user).length > 0) {
      setViewKey('logged-in');
    }
  }, [user, userFetchState]);

  const currentView = children?.filter(child => child.key === viewKey);

  return (
    <div {...addIdAttribute(dataTestId)}>
      {currentView}
    </div>
  );
}

AuthWrapper.propTypes = {
  children: PropTypes.node,
  dataTestId: PropTypes.string,
};

AuthWrapper.defaultProps = {
  children: [],
  dataTestId: null,
}

export default withChildren(AuthWrapper);
